import React from 'react';
import { ArrowRight } from 'lucide-react';
import Reveal from '@/components/Reveal';
import { SYSTEM_STEPS } from '@/data/metaOffer';

export default function MetaSystem() {
  return (
    <section id="system" className="bg-[#0B0B0B] border-t border-white/10 py-20 lg:py-28">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl mb-14">
          <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#3B82F6] block mb-4">
            The Method
          </span>
          <h2 className="font-display font-bold text-white tracking-tight text-3xl lg:text-5xl leading-tight">
            Our Proven Client Acquisition System
          </h2>
          <p className="mt-6 text-white/55 font-light leading-relaxed">
            Five stages, run in sequence. Nothing is scaled until the stage beneath it is verified — which is why the
            growth holds.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-5">
          {SYSTEM_STEPS.map((s, i) => (
            <Reveal key={s.step} delay={i * 0.08}>
              <div className="h-full rounded-lg border border-white/10 bg-white/[0.03] p-7 hover:border-[#3B82F6]/50 transition-colors duration-500">
                <span className="font-display font-bold text-3xl text-[#3B82F6]/40">{s.step}</span>
                <h3 className="mt-4 font-display font-bold text-lg text-white tracking-tight">{s.title}</h3>
                <p className="mt-3 text-sm text-white/55 font-light leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <a
            href="#breakdown"
            className="group mt-12 inline-flex items-center gap-2.5 px-8 h-14 rounded-lg bg-[#2563EB] text-white text-sm font-bold hover:bg-[#1D4ED8] transition-colors"
          >
            Get Your Free Meta Ads Breakdown
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}